import type { SegmentTrackingFilter } from '@bc/discovery';

export enum CatalogFilterEventName {
  FilterPanelClicked = 'Filter Panel Clicked',
  FilterApplied = 'Filter Applied',
}

export type CatalogFiltersEventProperties = {
  filter: string;
  active?: boolean;
  filters?: SegmentTrackingFilter<string | number | { min?: number; max?: number }>[];
  filtersQuery?: string;
  // The specific discount tier (e.g. "10_100") when `filter` is the discount facet, so it can be
  // grouped on directly - `filters` alone doesn't let analytics tools break down a nested array
  // by "the value of the entry named X".
  discount_tier?: string | null;
};
